<template>
  <div class="mazda-hp-content" :data-brand="brand.substr(0,1).toLowerCase() + brand.substr(1)">
    <section class="map-contact">
      <div class="section-space-sm">
        <div class="container container-xl">
          <div class="row flex-row align-items-center">
            <div class="col-xs-12 col-md-6">
              <div class="embed-responsive embed-responsive-16by9">
                <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12918.965734457683!2d-78.5415827!3d35.9532947!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89ac8d2f4f793355%3A0x48fb9827aaadbb1!2sSokal!5e0!3m2!1sen!2sus!4v1683052110316!5m2!1sen!2sus" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
              </div>
            </div>
            <div class="col-xs-12 col-md-6">
              <div class="content-box">
                <h4 class="contact-heading">Hometown Auto Dealer</h4>
                <p class="dealer-location">City, ST</p>
                <p class="dealer-address">123 Main Street, City, ST 27516</p>
                <div class="row">
                  <div class="col-xs-6">
                    <a class="white-link" href="#">
                      <img class="mazda-icon" alt="directions" src="../../static/images/common-icons/mazda-directions-white-01.png" v-if="brand.toLowerCase() === 'mazda'">
                      <i class="fa fa-map-marker" aria-hidden="true" v-else></i>
                      <span>Get Directions</span>
                    </a>
                  </div>
                  <div class="col-xs-6">
                    <a class="white-link" href="#">
                      <img class="mazda-icon" alt="phone" src="../../static/images/common-icons/mazda-phone-white-01.png" v-if="brand.toLowerCase() === 'mazda'">
                      <i class="fa fa-phone" aria-hidden="true" v-else></i>
                      <span>919-555-5555</span>
                    </a>
                  </div>
                </div>
                <h4 class="contact-heading hours-heading">Hours</h4>
                <div class="row contact-hours">
                  <div class="col-xs-6">
                    <h5 class="hours-heading">Sales</h5>
                    <p>M-F: 9am - 9pm</p>
                    <p>Sa: 9am - 7pm</p>
                    <p>Su: 12pm - 6pm</p>
                  </div>
                  <div class="col-xs-6">
                    <h5 class="hours-heading">Service</h5>
                    <p>M-F: 8am - 8pm</p>
                    <p>Sa: 8am - 6pm</p>
                    <p>Su: Closed</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      brand: this.$store.state.chosenBrand
    }
  },
  computed: {
    brandName () {
      if (this.brand === 'none') {
        return 'Brand';
      } else if (this.brand === 'infiniti' || this.brand === 'cjdr') {
        return this.brand.toUpperCase();
      } else {
        return this.brand.charAt(0).toUpperCase() + this.brand.slice(1);
      }
    }
  }
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
  .mazda-hp-content .map-contact {
    background: var(--primary-dark);
    color: #fff;
  }
  .mazda-hp-content .section-space-sm {
    padding-top: 30px;
    padding-bottom: 30px;
  }
  .mazda-hp-content .map-contact .content-box {
    padding: 30px;
    max-width: 460px;
    margin: auto;
  }
  .mazda-hp-content .map-contact h4,
  .mazda-hp-content .map-contact h5,
  .mazda-hp-content .map-contact .white-link {
    color: #fff !important;
    text-transform: uppercase;
  }
  .mazda-hp-content .map-contact p,
  .mazda-hp-content .map-contact .white-link {
    font-size: 13px;
    font-weight: 400;
  }
  .mazda-hp-content .map-contact .dealer-location {
    color: #999;
    margin-top: 0px;
  }
  .mazda-hp-content .map-contact .dealer-address {
    margin: 15px 0px;
  }
  .mazda-hp-content .map-contact .hours-heading {
    margin-top: 30px;
  }
  .mazda-hp-content .map-contact .mazda-icon,
  .mazda-hp-content .map-contact i {
    height: 12px;
    margin-right: 5px;
  }
  .mazda-hp-content .map-contact .contact-hours p, 
  .mazda-hp-content .map-contact h4 {
    margin-bottom: 5px;
  }
  .embed-responsive {
    background-image: url(../../static/images/map-and-contact-map-bg-01.png);
    background-size: cover;
    background-position: center;
  }
</style>
